window.vsvars = {
    version_number: "9.8.46",
    release_date: "May 28, 2025",
    modelsjson_version: "a398a8",
    cdnurl: "https://static.hamrick.com",
    baseurl: "https://www.hamrick.com",
    backendurl: "https://www.hamrick.com/a"
};
